export const openResponse = async (res, filename) => {
  const blob = await res.blob();
  let anchor = document.createElement('a');
  let objectUrl = window.URL.createObjectURL(blob);

  anchor.href = objectUrl;
  anchor.download = filename;
  anchor.click();
  anchor.remove();

  window.URL.revokeObjectURL(objectUrl);
};



// WEBPACK FOOTER //
// ./src/utils/links.js